const MV4_URL = 'https://tools.airfire.org/monitoring/v4/#!/'
const DATA_REPORTS_URL = 'https://tools.airfire.org/monitor-data-report/v4/report'

export function getMonitoringV4Links(pm25Data){
    if (pm25Data && pm25Data.length > 0) {
        try {
            let individualLinks = Object.values(pm25Data.reduce((r, e) => {
                r[e.monitor_id] = {
                    monitorId: e.monitor_id,
                    url: `${MV4_URL}?monitors=${e.monitor_id}`,
                    dataReportUrl: `${DATA_REPORTS_URL}?monitors=${e.monitor_id}`,
                    siteName: e.site_name,
                    county:e.county_name,
                    state: e.site_name
                }
                return r
            }, {}))

            let allLink = MV4_URL + '?' + individualLinks.map((e) => {
                    return `monitors=${e.monitorId}`
                }).join('&')

            return {
                individual: individualLinks,
                all: allLink
            }
        } catch(e){}
    }
    return {individual: null, all: null};
}

export function getWebSkyLinks(forecastData){
    if (forecastData) {
        try {
            return Object.values(forecastData.reduce((r, e) => {
                if (e.model_name_pretty == 'HRRR') {
                    r[e.model_name_pretty] = {
                        modelDomain: e.model_name_pretty,
                        url: `https://tools.airfire.org/websky/v2/${e.model_name}/smoke`
                    }
                }
                else
                    r[e.model_name_pretty] = {
                        modelDomain: e.model_name_pretty,
                        url: `https://tools.airfire.org/websky/v2/run/standard/${e.model_name}/latest?#viewer`
                    }
                return r
            }, {}))
        } catch(e){}
    }
    return [];
}
